/*******************************************************************************
Updates the winnings amounts displayed on a betting event card.
*******************************************************************************/

export default function updateWinnings(eventID, centsBet, multipliers) {

    // Map the elements to update to their multiplier value
    const multipliersMap = {
        '.ml-home'    : multipliers.ml.home,
        '.ml-away'    : multipliers.ml.away,
        '.spread-home': multipliers.spread.home,
        '.spread-away': multipliers.spread.away,
        '.ou-over'    : multipliers.ou.over,
        '.ou-under'   : multipliers.ou.under,
        '.distance-yes' : multipliers.distance.yes,
        '.distance-no' : multipliers.distance.no,
        '.decision-fighter1' : multipliers.decision.fighter1,
        '.decision-fighter2' : multipliers.decision.fighter2,
        '.knockout-fighter1' : multipliers.knockout.fighter1,
        '.knockout-fighter2' : multipliers.knockout.fighter2,
        '.submission-fighter1' : multipliers.submission.fighter1,
        '.submission-fighter2' : multipliers.submission.fighter2,
    };

    const elementsToUpdate = Object.keys(multipliersMap);
    elementsToUpdate.forEach((el) => {
        const newWinnings = Number((centsBet * multipliersMap[el]) / 100).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        const dollars = newWinnings.split('.')[0] || 0;
        const cents = newWinnings.split('.')[1] || 0;

        // Update the element with the new winnings value
        $(`.event[data-id="${eventID}"]`).find(el)
            .safehtml(`$${dollars}<span class="event__cents">.${cents}</span>`);
    });
}
